import { gql } from "graphql-request";

export const GET_ALL_DOCUMENTS = gql`
  query Documents($searchKeyword: String, $pageNo: Int, $pageSize: Int, $clientId: String, $tenantId: String) {
    documents(
      searchKeyword: $searchKeyword
      pageNo: $pageNo
      pageSize: $pageSize
      clientId: $clientId
      tenantId: $tenantId
    ) {
      data {
        _id
        createdAt
        addedByUser
        filename
        filerCodeAndEntryNo
        fileUrl
        tenantId
        entryDate
        ADD_CVV
        documentType
      }
      meta {
        countDocs
      }
    }
  }
`;

export const ADD_DOCUMENT = gql`
  mutation CreateDocument($document: CreateDocumentInput!, $clientId: String, $tenantId: String) {
    createDocument(document: $document, clientId: $clientId, tenantId: $tenantId) {
      data
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation DeleteDocument($id: ID!) {
    deleteDocument(_id: $id) {
      data
    }
  }
`;

